var map = {
	"./all_colors.png": 38872,
	"./christmas.png": 76406,
	"./color-rate.png": 63672,
	"./cool_colors.png": 46064,
	"./effects/cascade.png": 1607,
	"./effects/comet-coming.png": 69701,
	"./effects/comet.png": 60253,
	"./effects/marquee-coming.png": 40493,
	"./effects/marquee.png": 6085,
	"./effects/pattern.png": 9971,
	"./effects/race-coming.png": 93976,
	"./effects/race.png": 89598,
	"./effects/sparkle.png": 70623,
	"./effects/store.png": 60186,
	"./effects/strobe-coming.png": 83308,
	"./effects/strobe.png": 9282,
	"./effects/wave.png": 73538,
	"./effects/wave1-coming.png": 29529,
	"./effects/wave1.png": 10913,
	"./effects/wave2-coming.png": 22388,
	"./effects/wave2.png": 53482,
	"./halloween.png": 70647,
	"./heavy-sparkle.png": 82386,
	"./light-sparkle.png": 93111,
	"./medium-sparkle.png": 61020,
	"./red_white_and_blue.png": 84272,
	"./select_color.png": 17180,
	"./warm_colors.png": 19380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69962;